import React, { useState } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useAppStore } from '../../store/appStore';
import { EntityInspectorProvider } from '../../context/EntityInspectorContext';
import { UniversalInspectorDrawer } from '../entity';
import { McInspectorProvider } from '../../mission-control';
import { LAYOUT } from '../../design-system/foundation';
import './aurora-chrome.css';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const { toggleSidebar, sidebarCollapsed, setSidebarCollapsed } = useAppStore();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleMobileToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const collapseSidebarOnPageClick = () => {
    if (!isDesktop || sidebarCollapsed) return;
    setSidebarCollapsed(true);
  };

  return (
    <EntityInspectorProvider>
      <McInspectorProvider>
      <Box
        className={`app-shell-observatory v3-app-shell${sidebarCollapsed ? ' sidebar-collapsed' : ''}`}
        sx={{
          display: 'flex',
          height: '100vh',
          width: '100%',
          overflow: 'hidden',
          bgcolor: 'var(--au-bg)',
          position: 'relative',
        }}
      >
      <Sidebar
        open={isDesktop ? true : mobileOpen}
        onToggle={isDesktop ? toggleSidebar : handleMobileToggle}
      />
      <Box
        component="main"
        id="main-content"
        tabIndex={-1}
        onClick={collapseSidebarOnPageClick}
        sx={{
          flex: '1 1 auto',
          minWidth: 0,
          minHeight: 0,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Header onMenuClick={handleMobileToggle} />
        <Box
          component="section"
          id="app-main-section"
          sx={{
            flex: '1 1 auto',
            minHeight: 0,
            minWidth: 0,
            px: LAYOUT.pagePadX,
            pt: LAYOUT.pagePadTop,
            pb: 0,
            overflowX: 'hidden',
            overflowY: 'auto',
            width: '100%',
            maxWidth: 'none',
            boxSizing: 'border-box',
          }}
        >
          {children}
        </Box>
      </Box>
      </Box>
      <UniversalInspectorDrawer />
      </McInspectorProvider>
    </EntityInspectorProvider>
  );
};

export default Layout;
